export const EditorialTicker = ({ text, reverse = false, testid = "editorial-marquee-ticker" }) => {
  const chunk = text.repeat(4);
  return (
    <div data-testid={testid} className="overflow-hidden border-y border-line py-5 select-none" aria-hidden="true">
      <div className={`marquee-track ${reverse ? "reverse" : ""} flex whitespace-nowrap`}>
        {[0, 1].map((i) => (
          <span key={i} className="font-serif text-2xl sm:text-3xl italic text-ink3 pr-4">
            {chunk}
          </span>
        ))}
      </div>
    </div>
  );
};
